import { EMPTY_STRING } from '@constants';
import { Nullable } from '@customTypes';

export const getInnerHtmlText = (text?: Nullable<string>) => {
  if (!text) return EMPTY_STRING;

  return <span dangerouslySetInnerHTML={{ __html: text }} />;
};
